import { apiV2 } from "api/firebase";
import { useQuery } from "@tanstack/react-query";
import { RequestKey } from "api/request-key";

type Params = {
  standId: string;
  showId: string;
  taskId: string;
};
export const useLastTimelineAction = (params: Params, enabled = true) => {
  const { showId, standId, taskId } = params;
  const queryEnabled = enabled && Boolean(showId && standId && taskId);

  const { data, isFetching, isLoading } = useQuery({
    queryKey: [RequestKey.GetLastTaskTimelineAction, showId, standId, taskId],
    queryFn: async () => {
      try {
        return await apiV2.taskTimeline.getOne(params);
      } catch (e) {
        console.error("Error occurred retrieving history timeline action: ", e);
        return null;
      }
    },
    enabled: queryEnabled,
    staleTime: 60_000,
    cacheTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    refetchInterval: 0,
  });

  return [data, isLoading || isFetching] as const;
};
